import React, { useState, useEffect } from "react";
import { useHistory } from "react-router-dom";
import { Button, Typography, Paper, IconButton, Box } from "@material-ui/core";
import { DatePicker } from "antd";
import moment from "moment";
import "../../css/dataTable.css";
import { useTranslation } from "@/langs/useTranslation";
import * as $ from "jquery";
import "datatables.net";
import "datetime-moment";
import { ReplayOutlined } from "@material-ui/icons";
import { language } from "@/helpers/datatableSetting";
import modalConfirm from "../Modal/modalConfirm";
import { toast } from "@/helpers/toast";
import { ReactRender } from "../ReactRender";
import {
  getTermList,
  deleteTerm,
  exportTerm
} from "@/apis/announcementApi";
import SearchInput from "../SearchInput";
import useStyles from "../../styles/accessManagementStyle";
import { downloadBlob } from "@/helpers/utils";

const { RangePicker } = DatePicker;

const TermTable = ({ companyId }) => {
  const history = useHistory();
  const classes = useStyles();
  const { t } = useTranslation("accessManagement");
  const [searchValue, setSearchValue] = useState("");
  const [searchTime, setSearchTime] = useState([null, null]);

  const handleRemoveRoleDialogClickOpen = (id, name) => {
    modalConfirm({
      title: t({ defaultMessage: "删除公告" }),
      content: t({ defaultMessage: "是否删除[{name}]？" }, { name }),
      onConfirm: async () => {
        await deleteTerm({ids: [id]});
        toast.success(t({ defaultMessage: "删除成功" }));
        table();
      }
    });
  };

  const handleExport = async (id, name) => {
    const res = await exportTerm({
      id
    })
    const binaryData = Uint8Array.from(atob(res.file), (c) => c.charCodeAt(0));
    const blob = new Blob([binaryData], { type: 'application/octet-stream' });
    downloadBlob(blob, `${name}.xlsx`)//, 'application/zip')
  }

  const table = async (keywords = "", time) => {
    $("#announcement-table").DataTable({
      processing: true,
      language: language(t),
      searching: true,
      filter: false,
      deferRender: true,
      info: false,
      autoWidth: false,
      stateSave: false,
      destroy: true,
      pageLength: 9,
      ordering: false,
      order: [[0, "asc"]],
      ajax: (_data, callback) => {
        getTermList({
          page: 1,
          page_size: 100000,
          keywords
        }).then(res => {
          callback({
            data:
              res.terms.filter(item => {
                if (time && time[0] && time[1]) {
                  return (
                    Number(item.sendTime) >=
                      moment(time[0]).startOf("day").valueOf() &&
                    Number(item.sendTime) <=
                      moment(time[1]).endOf("day").valueOf()
                  );
                }
                return true;
              }) || []
          });
        });
      },
      columns: [
        {
          data: "name",
          name: "data.name",
          title: `${t({ defaultMessage: "标题" })}`,
          searchable: true,
          createdCell: (td, data) => {
            ReactRender(
              <Typography
                variant="body1"
                style={{
                  maxWidth: 260,
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                  whiteSpace: "nowrap"
                }}
              >
                {data}
              </Typography>,
              td
            );
          }
        },
        {
          data: "content",
          name: "data.content",
          title: `${t({ defaultMessage: "内容" })}`,
          searchable: true,
          createdCell: (td, data) => {
            ReactRender(
              <Typography
                variant="body1"
                style={{
                  maxWidth: 550,
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                  whiteSpace: "nowrap"
                }}
              >
                {data}
              </Typography>,
              td
            );
          }
        },
        {
          data: "createUserName",
          name: "data.createUserName",
          title: `${t({ defaultMessage: "发送人" })}`,
          searchable: true,
          createdCell: (td, data) => {
            ReactRender(
              <Typography
                variant="body1"
                style={{
                  maxWidth: 300,
                  overflow: "hidden",
                  textOverflow: "ellipsis"
                }}
              >
                {data}
              </Typography>,
              td
            );
          }
        },
        {
          data: "createTime",
          name: "data.createTime",
          title: `${t({ defaultMessage: "创建时间" })}`,
          searchable: true,
          createdCell: (td, data) => {
            ReactRender(
              <Typography variant="body1">
                {data === "0"
                  ? "-"
                  : moment(Number(data)).format("YYYY-MM-DD HH:mm:ss")}
              </Typography>,
              td
            );
          }
        },
        {
          data: "id",
          name: "data.id",
          title: `<span style="margin-left: 16px">${t({ defaultMessage: "操作" })}</span>`,
          searchable: true,
          createdCell: (td, data, rowData) => {
            const currentTime = moment().valueOf();

            ReactRender(
              <div style={{ whiteSpace: "nowrap" }}>
                <Button
                  size="small"
                  color="primary"
                  href={`/create-term/${rowData.id}/view`}
                  style={{ color: "#00afc6" }}
                >
                  {t({ defaultMessage: "查看" })}
                </Button>
                <Button
                  size="small"
                  color="primary"
                  onClick={() =>
                    handleExport(
                      rowData.id,
                      rowData.name
                    )
                  }
                >
                  {t({ defaultMessage: "导出" })}
                </Button>
                <Button
                  size="small"
                  color="secondary"
                  onClick={() =>
                    handleRemoveRoleDialogClickOpen(
                      rowData.id,
                      rowData.name
                    )
                  }
                >
                  {t({ defaultMessage: "删除" })}
                </Button>
              </div>,
              td
            );
          }
        }
      ]
    });
  };

  const handleReloadDataTable = () => {
    table(searchValue, searchTime);
  };

  useEffect(() => {
    table();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [companyId]);

  return (
    <Paper
      elevation={0}
      className="fullwidth-table-wrapper reset-margin-top-table"
    >
      <div className={classes.tableHeader}>
        <div style={{ display: "flex", alignItems: "center" }}>
          <Typography variant="h6">
            {t({ defaultMessage: "条款列表" })}
          </Typography>
          <IconButton
            aria-label="reload table"
            className={classes.margin}
            size="small"
            onClick={handleReloadDataTable}
          >
            <ReplayOutlined />
          </IconButton>
        </div>

        <Box display="flex">
          <SearchInput
            iconPosition="left"
            value={searchValue}
            onChange={e => {
              setSearchValue(e.target.value);
            }}
            className={classes.input}
            style={{ width: 300 }}
          />
          <Button
            variant="contained"
            color="primary"
            onClick={() => {
              history.push("/create-term");
            }}
            href="/create-term"
            style={{ backgroundColor: "#00afc6", color: "#fff" }}
          >
            {t({ defaultMessage: "创建条款" })}
          </Button>
        </Box>
      </div>
      <div style={{ display: "flex", alignItems: "center" }}>
        <span>{t({ defaultMessage: "发送时间" })}：</span>
        <RangePicker
          name="activeTime"
          value={searchTime}
          onChange={setSearchTime}
        />
        <Button
          variant="contained"
          color="primary"
          onClick={() => {
            table(searchValue, searchTime);
          }}
          style={{ backgroundColor: "#00afc6", color: "#fff", marginLeft: 10 }}
        >
          {t({ defaultMessage: "查询" })}
        </Button>
        <Button
          variant="contained"
          color="primary"
          onClick={() => {
            setSearchTime([null, null]);
            setSearchValue("");
            table();
          }}
          style={{
            backgroundColor: "#fff",
            color: "#ccc",
            border: "1px solid #ccc",
            marginLeft: 10
          }}
        >
          {t({ defaultMessage: "重置" })}
        </Button>
      </div>
      <div className="dataTables_spec">
        <table id="announcement-table" className="mdl-data-table noPaddingRight"></table>
      </div>
    </Paper>
  );
};

export default TermTable;
